import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/Forgot";
import Chat from "./pages/Chat";
import { getCookieToken } from "./utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./app/store";
import { loginState, logoutState } from "./features/auth/authSlice";
import SharedChat from "./pages/SharedChat";

// Protected Route Component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const loading = useSelector((state: RootState) => state.auth.loading); // You can manage loading globally, or pass loading prop

  if (loading) {
    return <div>Loading...</div>; // Show loading indicator while checking authentication status
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Check cookie to determine authentication status
    const authState = getCookieToken("isAuthenticated");

    if (authState) {
      dispatch(loginState()); // Set user as authenticated if token exists
    } else {
      dispatch(logoutState()); // Log out if no token exists
    }
    setLoading(false); // Finish loading
  }, [dispatch]); // Keep dependency array to just dispatch to avoid infinite loops

  if (loading) {
    // Show a loading spinner while checking authentication
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password/:token" element={<ChangePassword />} />
        <Route path="/share/:chatId" element={<SharedChat />} />

        {/* Protected Route */}
        <Route
          path="/chat/:chatID?" 
          element={
            <ProtectedRoute>
              <Chat />
            </ProtectedRoute>
          }
        />

        {/* Redirect all other routes to login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
